//TODO: Pull from the commerce packages once it is moved to shared
export function extractAsinFromUrl(url: string): string | undefined {
    try {
        let formatted = new URL(url);

        // check for the beta redirect url format
        if (formatted.host.includes('prod.ozone.publishers.advertising.a2z.com')) {
            const subUrl = formatted.searchParams.get('rUrl');

            if (subUrl === null) {
                return undefined;
            }

            formatted = new URL(subUrl);
        }

        if (formatted.host.includes('amazon.')) {
            const identified = formatted.pathname.match('(([dg]p|product)/([A-Z0-9]{10}))');

            return identified === null ? undefined : identified[3];
        }
    } catch {
        /* no op */
    }

    return undefined;
}

export function extractAscTagFromUrl(url: string): string | undefined {
    try {
        const formatted = new URL(url);

        const matches = formatted.search.match(/tag=(?<tag>[a-zA-Z0-9_-]+)/);
        if (matches) {
            return matches.groups?.tag;
        }
    } catch {
        /* no op */
    }

    return undefined;
}

export function getUtmParams(search?: Record<string, string>): Record<string, Function> {
    const searchParams = search ?? document.location.search;
    const urlParams = new URLSearchParams(searchParams);
    const utmParams: Record<string, Function> = {};
    urlParams.forEach((v, k) => {
        if (k.startsWith('utm_')) {
            utmParams[k] = () => {
                return v;
            };
        }
    });
    return utmParams;
}
